export const Instagram = () => {
  return (
    <section className='instagram'>
      <h2 className='text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl'>
        Instagram
      </h2>
      <a
        className='transition duration-100 rounded-md instagram__button'
        target='_blank'
        rel='noreferrer'
        href='https://www.instagram.com/artstudio.fukla/'
      >
        Последвайте ни на @artstudio.fukla
      </a>
    </section>
  );
};
